import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon_order_wait.png'
import _imports_1 from '@/assets/image/icon_order_accept.png'
import _imports_2 from '@/assets/image/icon_order_cancel.png'
import _imports_3 from '@/assets/image/icon_order_completed.png'
import _imports_4 from '@/assets/image/icon_order_determined.png'
import _imports_5 from '@/assets/image/icon_order_cancel_contacts.png'


const _withScopeId = n => (_pushScopeId("data-v-420f6dc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help" }
const _hoisted_2 = { class: "help_item border_dashed" }
const _hoisted_3 = { class: "jifen_part border_bottom_dashed" }
const _hoisted_4 = { class: "jifen_part" }
const _hoisted_5 = { class: "jifen" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_left" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_right" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "title_icon",
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  class: "title_icon",
  src: _imports_1
}
const _hoisted_10 = {
  key: 2,
  class: "title_icon",
  src: _imports_2
}
const _hoisted_11 = {
  key: 3,
  class: "title_icon",
  src: _imports_3
}
const _hoisted_12 = {
  key: 4,
  class: "title_icon",
  src: _imports_4
}
const _hoisted_13 = { class: "path_part_background" }
const _hoisted_14 = { class: "path_part" }
const _hoisted_15 = { class: "path_part_title" }
const _hoisted_16 = { class: "path_part_detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "conntLine" }, null, -1))
const _hoisted_18 = { class: "path_part_background path-part-background-gray" }
const _hoisted_19 = { class: "path_part" }
const _hoisted_20 = { class: "path_part_title" }
const _hoisted_21 = { class: "path_part_detail" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "conntLine" }, null, -1))
const _hoisted_23 = { class: "path_part_background" }
const _hoisted_24 = { class: "path_part" }
const _hoisted_25 = { class: "path_part_title" }
const _hoisted_26 = { class: "path_part_detail" }
const _hoisted_27 = {
  key: 0,
  class: "button_part"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "write_button_part"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "contacts_part"
}
const _hoisted_35 = { class: "contacts_background" }
const _hoisted_36 = { class: "part1" }
const _hoisted_37 = { class: "contacts_left" }
const _hoisted_38 = { class: "contacts_right" }
const _hoisted_39 = { class: "line1" }
const _hoisted_40 = { class: "line1_name" }
const _hoisted_41 = {
  key: 1,
  class: "line1_workinghours"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_5
}, null, -1))
const _hoisted_43 = { class: "telphone" }
const _hoisted_44 = { class: "part2" }
const _hoisted_45 = { class: "address" }
const _hoisted_46 = {
  key: 1,
  class: "submitButton_part"
}
const _hoisted_47 = {
  key: 2,
  class: "submitButton_part"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.View_Detail, _ctx.itemData)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.itemData.payPoint) + "积分", 1),
            _hoisted_6,
            _hoisted_7,
            (_ctx.itemData.helpStatus == 8)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.itemData.helpStatus == 3)
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.itemData.helpStatus == 4)
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.itemData.helpStatus == 6)
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.itemData.helpStatus == 9)
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_van_icon, {
              class: "path_part_icon",
              size: "26px",
              name: "location-o",
              color: "#ffffff"
            }),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.itemData.toAddress), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.itemData.toProvince) + _toDisplayString(_ctx.itemData.toCity) + _toDisplayString(_ctx.itemData.toDistrict), 1),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_van_icon, {
              class: "path_part_icon",
              size: "26px",
              name: "certificate",
              color: "#ffffff"
            }),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.itemData.title), 1),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.format(_ctx.itemData.needTime, "yyyy-MM-dd HH:mm")), 1),
            _hoisted_22
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_van_icon, {
              class: "path_part_icon",
              size: "26px",
              name: "location-o",
              color: "#ffffff"
            }),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.itemData.targetAddress), 1),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.itemData.targetProvince) + _toDisplayString(_ctx.itemData.targetCity) + _toDisplayString(_ctx.itemData.targetDistrict), 1)
          ])
        ])
      ]),
      (_ctx.isHomePage == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_van_button, {
              disabled: _ctx.itemData.helpStatus == 6,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.Take_Order, _ctx.itemData))),
              class: "takeButton d-theme-btn",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 马上接单 ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_van_button, {
              class: "checkButton d-theme-btn",
              type: "primary",
              onClick: _ctx.goDetails
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看详情 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.itemData.isMy == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (
          _ctx.itemData.helpStatus == 1 || _ctx.itemData.helpStatus == 2 || _ctx.itemData.helpStatus == 3 || _ctx.itemData.helpStatus == 5 || _ctx.itemData.helpStatus == 8
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_van_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.getWhiteButtonMsg(), _ctx.itemData))),
                    class: "whiteButton"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "icon",
                        src: _ctx.getWhiteButtonIcon(0)
                      }, null, 8, _hoisted_30),
                      _createTextVNode(_toDisplayString(_ctx.getWhiteButtonLabel(0)), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.itemData.helpStatus != 3)
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.Order_Refresh, _ctx.itemData))),
                        class: "whiteButton"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "icon",
                            src: _ctx.getWhiteButtonIcon(1)
                          }, null, 8, _hoisted_31),
                          _createTextVNode(_toDisplayString(_ctx.getWhiteButtonLabel(1)), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.Order_Detele, _ctx.itemData))),
                    class: "whiteButton"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "icon",
                        src: _ctx.getWhiteButtonIcon(2)
                      }, null, 8, _hoisted_32),
                      _createTextVNode(_toDisplayString(_ctx.getWhiteButtonLabel(2)), 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_33
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.itemData.helpStatus == 3 && _ctx.itemData.hasOwnProperty('orderUser'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_van_image, {
                  class: "contacts_image",
                  alt: "图片加载中...",
                  fit: "cover",
                  src: _ctx.img(_ctx.itemData.orderUser.headUrl),
                  radius: "50%"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.itemData.orderUser.userName), 1),
                  (_ctx.itemData.isMy == true)
                    ? (_openBlock(), _createBlock(_component_van_tag, {
                        key: 0,
                        size: "large",
                        class: "line1_tag",
                        plain: "",
                        round: "",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 已完成" + _toDisplayString(_ctx.itemData.orderUser.orderCount) + "次订单", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.itemData.isMy == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.itemData.orderUser.workTime) + " 志愿者工时 ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.itemData.isMyOrder == true)
                    ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 2,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.Contacts_Cancel_Btn, _ctx.itemData))),
                        class: "contacts_cancel_btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createTextVNode(" 取消 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.itemData.orderUser.phone), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, "所在地： " + _toDisplayString(_ctx.itemData.targetProvince) + _toDisplayString(_ctx.itemData.targetCity) + _toDisplayString(_ctx.itemData.targetDistrict), 1),
              _createVNode(_component_van_button, {
                class: "contacts_btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, _ctx.Contacts_Btn, _ctx.itemData)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("马上联系 ")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.itemData.isMy == true && _ctx.itemData.helpStatus == 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_van_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, this.Order_Comfin_Republish, _ctx.itemData))),
            block: "",
            class: "submitButton d-theme-btn",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 重新发布 ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.itemData.isMy == false && _ctx.itemData.helpStatus == 3 && _ctx.itemData.isMyOrder == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createVNode(_component_van_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClick(_ctx.itemData.id, this.Order_Comfin_Finish, _ctx.itemData))),
            block: "",
            class: "submitButton d-theme-btn",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 我已完成 ")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}